/* @license react-google-recaptcha-ultimate v1.2.2 */
var a=function(){return".grecaptcha-badge{display: none !important;}"};export{a as generateGoogleReCaptchaHiddenBadgeStyles};
//# sourceMappingURL=generateGoogleReCaptchaHiddenBadgeStyles.js.map
